/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Grid, IconButton, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { MFTextField } from '../../lib/formik';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import MFCheckbox from '../../lib/formik/Checkbox';
import { NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  checkAddressField,
  checkValidationBasedOnDate,
  getApplicantName,
  getNomineeRelation,
  ifPushToXalt,
  isMinor,
  isOnboardingTypeMinor,
  removeSingleQuote,
  saveForLater,
  statusRoleBased,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import {
  NomineeIdFieldValidationDate,
  NomineeRelations,
  nomineeValidationDate,
  otherRelations,
} from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';

type updateNominee = NomineeType & {
  Relationship: string | null;
  sno?: number;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  saveType: string;
  countryDropdown: string[];
};

const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  nomineePan: '',
  nomineeGuardianPan: '',
  isActive: true,
  Relationship: '',
  sno: 0,
  guardianDOB: null,
  nomineeAddress1: '',
  nomineeAddress2: '',
  nomineeAddress3: '',
  nomineeCity: '',
  nomineeState: '',
  nomineePincode: '',
  nomineeCountry: '',
  guardianAddress1: '',
  guardianAddress2: '',
  guardianAddress3: '',
  guardianCity: '',
  guardianState: '',
  guardianCountry: '',
  guardianPincode: '',
  addressSameAsApplicant: false,
};

const initialValues: Values = {
  doNotWishToNominate: true,
  nominees: [newNominee],
  saveType: 'save and proceed',
  countryDropdown: [],
};

const Nominee = ({
  nomineeName,
  index,
  values,
  nationalitiesMdmsResponse,
  address,
  createdAt,
  ifXalt,
  ifTopUp,
}: {
  nomineeName: number;
  index: number;
  values: Values;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  address: any;
  createdAt: string;
  ifXalt: boolean;
  ifTopUp: boolean;
}): JSX.Element => {
  const { dateOfBirth = '' } = values.nominees[index];
  const { setFieldValue, setValues } = useFormikContext();

  const { application } = useSelector((store: RootStateType) => store.application);

  useEffect(() => {
    setValues({
      ...values,
      nominees: values.nominees.map((nominee, i) => {
        if (i === index) {
          return {
            ...nominee,
            guardianAddress1:
              nominee.guardianAddress1 === null
                ? checkAddressField(address?.address1)
                : nominee.guardianAddress1,
            guardianAddress2:
              nominee.guardianAddress2 === null
                ? checkAddressField(address?.address2)
                : nominee.guardianAddress2,
            guardianAddress3:
              nominee.guardianAddress3 === null
                ? checkAddressField(address?.address3)
                : nominee.guardianAddress3,
            guardianCity: nominee.guardianCity === null ? address?.city : nominee.guardianCity,
            guardianState: nominee.guardianState === null ? address?.state : nominee.guardianState,
            guardianCountry:
              nominee.guardianCountry === null
                ? address?.country
                : nominee.guardianCountry?.toUpperCase(),
            guardianPincode:
              nominee.guardianPincode === null ? address?.pincode : nominee.guardianPincode,
          };
        }
        return nominee;
      }),
    });
  }, [values.nominees[index].dateOfBirth]);
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineeName`}
          label={`Nominee Name ${nomineeName} *`}
          placeholder={`Enter Nominee Name ${nomineeName}`}
          disabled={ifTopUp}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`nominees.${index}.Relationship`}
          label="Nominee Relationship *"
          items={
            // checkValidationBasedOnDate(createdAt, nomineeValidationDate)
            (ifXalt ? NomineeRelations.concat(otherRelations) : NomineeRelations)
              .filter((relation) => {
                const { nominees } = values;
                const selectedRelations = nominees
                  .filter(
                    (nominee, ind) =>
                      ind !== index &&
                      nominee.Relationship &&
                      nominee.isActive &&
                      ['MOTHER', 'FATHER', 'SPOUSE'].includes(nominee.Relationship)
                  )
                  .map((nominee) => nominee.Relationship);
                return !selectedRelations.includes(relation);
              })
              .map((relation) => ({
                key: relation,
                value: relation,
              }))
          }
          disabled={ifTopUp}
        />
        {values.nominees.map((nominee, idx: number) => {
          if (
            nominee.Relationship === 'OTHERS' &&
            idx === index &&
            // !checkValidationBasedOnDate(createdAt, nomineeValidationDate)
            !ifXalt
          ) {
            return (
              <MFTextField
                name={`nominees.${index}.nomineeRelationship`}
                label="Please Specify Relationship *"
                placeholder={`Enter Nominee Relationship`}
                disabled={ifTopUp}
              />
            );
          }
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        <DatePicker
          label={'Date of birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of birth'}
          name={`nominees.${index}.dateOfBirth`}
          disabled={ifTopUp}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineePercentage`}
          label="Nominee % *"
          placeholder="Enter Nominee %"
          disabled={ifTopUp}
        />
      </Grid>
      {/* <---------Nominee Address-------> */}
      <Grid item xs={12}>
        <MFCheckbox
          name={`nominees.${index}.addressSameAsApplicant`}
          label="Nominee Address Same As Applicant"
          sx={{ letterSpacing: '1px' }}
          onChange={({ target: { checked } }) =>
            setValues({
              ...values,
              nominees: values.nominees.map((nominee, i) => {
                if (i === index) {
                  return {
                    ...nominee,
                    addressSameAsApplicant: checked,
                    ...(!checked && {
                      nomineeAddress1: '',
                      nomineeAddress2: '',
                      nomineeAddress3: '',
                      nomineeCity: '',
                      nomineeState: '',
                      nomineePincode: '',
                      nomineeCountry: '',
                    }),
                  };
                }
                return nominee;
              }),
            })
          }
          checked={values.nominees[index].addressSameAsApplicant}
        />
      </Grid>
      {!values.nominees[index].addressSameAsApplicant && (
        <>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeAddress1`}
              label={`Nominee Address Line 1 *`}
              placeholder="Enter Nominee Address Line 1"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeAddress2`}
              label={`Nominee Address Line 2 *`}
              placeholder="Enter Nominee Address Line 2"
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeAddress3`}
              label={`Nominee Address Line 3 *`}
              placeholder="Enter Nominee Address Line 3"
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineePincode`}
              label={`Nominee Pincode *`}
              placeholder="Enter Nominee Pincode"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeCity`}
              label={`Nominee City *`}
              placeholder="Enter Nominee City"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeState`}
              label={`Nominee State *`}
              placeholder="Enter Nominee State"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SearchableSelect
              name={`nominees.${index}.nomineeCountry`}
              label="Nominee Country *"
              items={nationalitiesMdmsResponse.map((nationality) => ({
                key: nationality.name,
                value: nationality.name,
              }))}
              searchFieldPlaceholder={'Search Country'}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineePan`}
          label={`Nominee ID ${
            checkValidationBasedOnDate(application?.createdAt || '', NomineeIdFieldValidationDate)
              ? '*'
              : ''
          }`}
          placeholder="Enter Nominee ID"
          inputProps={{ style: { textTransform: 'uppercase' } }}
          onChange={(e) => {
            setFieldValue(`nominees.${index}.nomineePan`, e.target.value.toUpperCase());
          }}
          disabled={ifTopUp}
        />
      </Grid>
      {isMinor(dateOfBirth ? dateOfBirth : '') && (
        <>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianName`}
              label="Guardian Name *"
              placeholder="Enter Guardian Name"
              disabled={ifTopUp}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label={'Guardian Date of Birth *'}
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              placeholder={'Enter Guardian Date of Birth'}
              name={`nominees.${index}.guardianDOB`}
              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeGuardianPan`}
              label="Guardian PAN"
              placeholder="Enter Guardian Pan"
              inputProps={{ style: { textTransform: 'uppercase' } }}
              onChange={(e) => {
                setFieldValue(`nominees.${index}.nomineeGuardianPan`, e.target.value.toUpperCase());
              }}
              disabled={ifTopUp}
            />
          </Grid>
          {/* <---------Guardian Address-------> */}
          <>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianAddress1`}
                label={`Guardian Address Line 1 *`}
                placeholder="Enter Guardian Address Line 1"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianAddress2`}
                label={`Guardian Address Line 2 *`}
                placeholder="Enter Guardian Address Line 2"
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianAddress3`}
                label={`Guardian Address Line 3 *`}
                placeholder="Enter Guardian Address Line 3"
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianPincode`}
                label={`Guardian Pincode *`}
                placeholder="Enter Guardian Pincode"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianCity`}
                label={`Guardian City *`}
                placeholder="Enter Guardian City"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianState`}
                label={`Guardian State *`}
                placeholder="Enter Guardiane State"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <SearchableSelect
                name={`nominees.${index}.guardianCountry`}
                label="Guardian Country *"
                items={nationalitiesMdmsResponse.map((nationality) => ({
                  key: nationality.name,
                  value: nationality.name,
                }))}
                searchFieldPlaceholder={'Search Country'}
              />
            </Grid>
          </>
        </>
      )}
    </>
  );
};

export default function NomineeDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  // const [nomineesToDelete, setNomineesToDelete] = useState<
  //   | {
  //       nominee: Partial<NomineeType>;
  //       // index: number;
  //     }[]
  //   | null
  // >(null);
  const [bulkNomineeDelete, setBulkNomineeDelete] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const ifXalt = ifPushToXalt(application?.pushDataTo || '');

  const onSubmit = async (values: Values) => {
    try {
      const {
        nominees: existingNominees = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        applicants = [],
        applicationNumber,
        createdAt,
        topupApplicationNumber,
      } = application || {};
      const { nominees, doNotWishToNominate, saveType } = values;
      const paramanantAddress = applicants
        .find((applicant) => applicant.applicant_type === '1')
        ?.addresses?.find((address) => address.address_type?.toLowerCase() === 'permanent');
      const nomineeAddressFieldValue = (
        nomineeAddressField: string | null | undefined,
        paramanentAddressField: string | null | undefined,
        addressSameAsApplicant: boolean
      ): string | null | undefined => {
        return removeSingleQuote(
          addressSameAsApplicant ? paramanentAddressField : nomineeAddressField
        );
      };
      const updatedPayload = {
        ...application,
        doNotWishToNominate,
        nominees: nominees
          .filter((nominee) => nominee?.id || nominee.isActive)
          .map((nominee, index) => {
            const { id = null } = existingNominees[index] || {};
            if (nominee.id === id) {
              const { Relationship, sno, ...rest } = nominee;
              return {
                ...(existingNominees[index] || {}),
                ...rest,
                nomineeRelationship: ifXalt
                  ? Relationship
                  : removeSingleQuote(rest.nomineeRelationship),
                dateOfBirth: !nominee.dateOfBirth
                  ? null
                  : new Date(nominee.dateOfBirth).toISOString(),
                isActive: nominee.isActive && !doNotWishToNominate,
                nomineeName: removeSingleQuote(rest.nomineeName),
                guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianName)
                  : null,
                nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.nomineeGuardianPan)
                  : null,
                nomineePercentage:
                  nominee.nomineePercentage === 0 || nominee.nomineePercentage
                    ? Number(nominee.nomineePercentage)
                    : null,
                guardianDOB: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? !rest.guardianDOB
                    ? null
                    : new Date(rest.guardianDOB).toISOString()
                  : null,
                guardianAddress1: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianAddress1)
                  : null,
                guardianAddress2: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianAddress2)
                  : null,
                guardianAddress3: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianAddress3)
                  : null,
                guardianPincode: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianPincode)
                  : null,
                guardianCity: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianCity)
                  : null,
                guardianState: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? removeSingleQuote(rest.guardianState)
                  : null,
                guardianCountry: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                  ? rest.guardianCountry
                  : null,
                nomineeAddress1: nomineeAddressFieldValue(
                  rest.nomineeAddress1,
                  paramanantAddress?.address1,
                  rest.addressSameAsApplicant
                ),
                nomineeAddress2: nomineeAddressFieldValue(
                  rest.nomineeAddress2,
                  paramanantAddress?.address2,
                  rest.addressSameAsApplicant
                ),
                nomineeAddress3: nomineeAddressFieldValue(
                  rest.nomineeAddress3,
                  paramanantAddress?.address3,
                  rest.addressSameAsApplicant
                ),
                nomineeCity: nomineeAddressFieldValue(
                  rest.nomineeCity,
                  paramanantAddress?.city,
                  rest.addressSameAsApplicant
                ),
                nomineeState: nomineeAddressFieldValue(
                  rest.nomineeState,
                  paramanantAddress?.state,
                  rest.addressSameAsApplicant
                ),
                nomineePincode: nomineeAddressFieldValue(
                  rest.nomineePincode,
                  paramanantAddress?.pincode,
                  rest.addressSameAsApplicant
                ),
                nomineeCountry: rest.addressSameAsApplicant
                  ? paramanantAddress?.country
                  : rest.nomineeCountry,
              };
            }
            const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
            return {
              ...rest1,
              nomineeRelationship: ifXalt
                ? Relationship
                : removeSingleQuote(rest1.nomineeRelationship),
              nomineeName: removeSingleQuote(rest1.nomineeName),
              guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianName)
                : null,
              nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.nomineeGuardianPan)
                : null,
              guardianDOB: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? !rest1.guardianDOB
                  ? null
                  : new Date(rest1.guardianDOB).toISOString()
                : null,
              guardianAddress1: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianAddress1)
                : null,
              guardianAddress2: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianAddress2)
                : null,
              guardianAddress3: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianAddress3)
                : null,
              guardianPincode: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianPincode)
                : null,
              guardianCity: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianCity)
                : null,
              guardianState: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? removeSingleQuote(rest1.guardianState)
                : null,
              guardianCountry: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                ? rest1.guardianCountry
                : null,
              nomineeAddress1: nomineeAddressFieldValue(
                rest1.nomineeAddress1,
                paramanantAddress?.address1,
                rest1.addressSameAsApplicant
              ),
              nomineeAddress2: nomineeAddressFieldValue(
                rest1.nomineeAddress2,
                paramanantAddress?.address2,
                rest1.addressSameAsApplicant
              ),
              nomineeAddress3: nomineeAddressFieldValue(
                rest1.nomineeAddress3,
                paramanantAddress?.address3,
                rest1.addressSameAsApplicant
              ),
              nomineeCity: nomineeAddressFieldValue(
                rest1.nomineeCity,
                paramanantAddress?.city,
                rest1.addressSameAsApplicant
              ),
              nomineeState: nomineeAddressFieldValue(
                rest1.nomineeState,
                paramanantAddress?.state,
                rest1.addressSameAsApplicant
              ),
              nomineePincode: nomineeAddressFieldValue(
                rest1.nomineePincode,
                paramanantAddress?.pincode,
                rest1.addressSameAsApplicant
              ),
              nomineeCountry: rest1.addressSameAsApplicant
                ? paramanantAddress?.country
                : rest1.nomineeCountry,
            };
          }),
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          nominees: application?.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
        },
        {
          ...updatedPayload,
          nominees: updatedPayload.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
          currentStep: !!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status: statusRoleBased(role, application),
              currentStep: 6,
              //!!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        !isSaveLater
          ? history.push('bank-details', {
              id,
              applicant1ReferenceId,
              topUpApplication: application?.isTopup,
            })
          : history.push(saveForLater(role, id, applicant1ReferenceId, application?.isTopup), {
              topUpApplication: application?.isTopup,
            });
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(
            `Application ${application?.isTopup ? topupApplicationNumber : applicationNumber} - ` +
              ' Saved successfully',
            {
              variant: 'success',
              autoHideDuration: 3000,
            }
          );
        }
        !isSaveLater
          ? history.push('bank-details', {
              id,
              applicant1ReferenceId,
              topUpApplication: application?.isTopup,
            })
          : history.push(saveForLater(role, id, applicant1ReferenceId, application?.isTopup), {
              topUpApplication: application?.isTopup,
            });
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };
  const [ModeOfHolding, SetModeOfHolding] = useState<boolean>(true);
  const [address, setAddress] = useState<any>();

  useEffect(() => {
    (async function () {
      try {
        const {
          nominees = [],
          doNotWishToNominate = true,
          onboardingType = '',
          modeOfHolding = '',
          applicants = [],
        } = application || {};
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const paramanantAddress = applicants
          .find((applicant) => applicant.applicant_type === '1')
          ?.addresses?.find((address) => address.address_type?.toLowerCase() === 'permanent');
        setAddress(paramanantAddress);
        SetModeOfHolding(modeOfHolding === 'single');
        setNomineesData(
          modeOfHolding === 'single' && nominees.filter((nominee) => nominee.isActive).length === 0
            ? {
                ...initialValues,
                doNotWishToNominate: isOnboardingTypeMinor(onboardingType),
                nominees: isOnboardingTypeMinor(onboardingType)
                  ? []
                  : [
                      {
                        ...newNominee,
                        addressSameAsApplicant: true,
                        nomineePercentage: 100,
                        nomineeAddress1: '',
                        nomineeAddress2: '',
                        nomineeAddress3: '',
                        nomineeCity: '',
                        nomineeState: '',
                        nomineeCountry: '',
                        nomineePincode: '',
                        guardianAddress1: checkAddressField(paramanantAddress?.address1),
                        guardianAddress2: checkAddressField(paramanantAddress?.address2),
                        guardianAddress3: checkAddressField(paramanantAddress?.address3),
                        guardianCity: paramanantAddress?.city,
                        guardianState: paramanantAddress?.state,
                        guardianCountry: paramanantAddress?.country?.toUpperCase(),
                        guardianPincode: paramanantAddress?.pincode,
                      },
                    ],
                countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
              }
            : {
                ...nomineesData,
                doNotWishToNominate: isOnboardingTypeMinor(onboardingType)
                  ? true
                  : modeOfHolding === 'single'
                  ? false
                  : nominees.length
                  ? false
                  : doNotWishToNominate === null
                  ? true
                  : doNotWishToNominate,
                nominees: nominees.length
                  ? nominees.map((nominee, index) => ({
                      ...nominee,
                      Relationship:
                        // checkValidationBasedOnDate(
                        //   application?.createdAt || '',
                        //   nomineeValidationDate
                        // )
                        ifXalt
                          ? nominee.nomineeRelationship
                          : getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
                          ? nominee.nomineeRelationship
                            ? nominee.nomineeRelationship.toUpperCase()
                            : nominee.nomineeRelationship
                          : 'OTHERS',
                      nomineeRelationship:
                        // checkValidationBasedOnDate(
                        //   application?.createdAt || '',
                        //   nomineeValidationDate
                        // )
                        ifXalt
                          ? ''
                          : getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
                          ? ''
                          : nominee.nomineeRelationship,
                      sno: index,
                      nomineePercentage: nominee.nomineePercentage
                        ? nominee.nomineePercentage
                        : nominees.length === 1
                        ? 100
                        : 0,
                      isActive: isOnboardingTypeMinor(onboardingType)
                        ? !nominee.isActive
                        : nominee.isActive,
                      guardianAddress1: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianAddress1
                          ? nominee.guardianAddress1
                          : ''
                        : null,
                      guardianAddress2: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianAddress2
                          ? nominee.guardianAddress2
                          : ''
                        : null,
                      guardianAddress3: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianAddress3
                          ? nominee.guardianAddress3
                          : ''
                        : null,
                      guardianCity: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianCity
                          ? nominee.guardianCity
                          : ''
                        : null,
                      guardianState: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianState
                          ? nominee.guardianState
                          : ''
                        : null,
                      guardianCountry: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianCountry
                          ? nominee.guardianCountry?.toUpperCase()
                          : ''
                        : null,
                      guardianPincode: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                        ? nominee.guardianPincode
                          ? nominee.guardianPincode
                          : ''
                        : null,
                      addressSameAsApplicant: nominee.addressSameAsApplicant || false,
                      nomineeAddress1: nominee.addressSameAsApplicant
                        ? ''
                        : nominee.nomineeAddress1,
                      nomineeAddress2: nominee.addressSameAsApplicant
                        ? ''
                        : nominee.nomineeAddress2,
                      nomineeAddress3: nominee.addressSameAsApplicant
                        ? ''
                        : nominee.nomineeAddress3,
                      nomineeCity: nominee.addressSameAsApplicant ? '' : nominee.nomineeCity,
                      nomineeState: nominee.addressSameAsApplicant ? '' : nominee.nomineeState,
                      nomineeCountry: nominee.addressSameAsApplicant
                        ? ''
                        : nominee?.nomineeCountry?.toUpperCase() || '',
                      nomineePincode: nominee.addressSameAsApplicant ? '' : nominee.nomineePincode,
                    }))
                  : [],
                countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
              }
        );
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const { onboardingType = '' } = application || {};

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            nomineeDetailsSchema(
              ifPushToXalt(application?.pushDataTo || ''),
              application?.applicants,
              application?.createdAt || ''
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues, errors }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes displayContent={'Investor(s) have the option to choose upto three nominees'} />
          {(!ModeOfHolding || isOnboardingTypeMinor(onboardingType)) && (
            <Grid item xs={12}>
              <MFCheckbox
                // disabled={!!values.nominees.length}
                disabled={
                  isOnboardingTypeMinor(application?.onboardingType || '') ||
                  application?.isTopup ||
                  false
                }
                name="doNotWishToNominate"
                label="I do not wish to nominate."
                sx={{ letterSpacing: '1px' }}
                onChange={({ target: { checked } }) => {
                  const updatedNominees = !checked
                    ? [
                        ...values.nominees,
                        {
                          ...newNominee,
                          addressSameAsApplicant: true,
                          nomineePercentage: 100,
                          sno: values.nominees.length,
                          nomineeAddress1: checkAddressField(address?.address1),
                          nomineeAddress2: checkAddressField(address?.address2),
                          nomineeAddress3: checkAddressField(address?.address3),
                          nomineeCity: address?.city,
                          nomineeState: address?.state,
                          nomineeCountry: address?.country?.toUpperCase(),
                          nomineePincode: address?.pincode,
                          guardianAddress1: checkAddressField(address?.address1),
                          guardianAddress2: checkAddressField(address?.address2),
                          guardianAddress3: checkAddressField(address?.address3),
                          guardianCity: address?.city,
                          guardianState: address?.state,
                          guardianCountry: address?.country?.toUpperCase(),
                          guardianPincode: address?.pincode,
                        },
                      ]
                    : values.nominees;
                  setValues({
                    ...nomineesData,
                    doNotWishToNominate:
                      values.nominees?.filter((item) => item.isActive).length === 0
                        ? checked
                        : !checked,
                    nominees: updatedNominees.map((nominee) => ({
                      ...nominee,
                    })),
                  });
                  checked && setBulkNomineeDelete(true);
                }}
                checked={values.doNotWishToNominate}
              />
            </Grid>
          )}
          <>
            {values.nominees
              .filter((_nominee) => _nominee.isActive)
              .map((nominee, index) => (
                <React.Fragment key={index}>
                  <SubHeading
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                    }}>
                    {getApplicantName(index + 1, true)} Nominee Details
                    {((ModeOfHolding &&
                      values.nominees.filter((nominee) => nominee.isActive).length !== 1) ||
                      !ModeOfHolding) &&
                      !application?.isTopup && (
                        <Box
                          sx={{ display: 'flex', alignItems: 'center' }}
                          onClick={() =>
                            setNomineeToDelete({ nominee, index: nominee.sno as number })
                          }>
                          <Typography
                            sx={{
                              color: 'rgba(196, 42, 51, 0.8)',
                              fontSize: 12,
                              ml: 'auto',
                              letterSpacing: '-0.2px',
                              cursor: 'pointer',
                            }}>
                            Remove Nominee{' '}
                          </Typography>
                          <IconButton sx={{ p: '2px' }}>
                            <CardMedia
                              component="img"
                              src="/images/delete-red.svg"
                              alt="Delete Icon"
                              sx={{ width: 'unset' }}
                            />
                          </IconButton>
                        </Box>
                      )}
                  </SubHeading>
                  <Nominee
                    nomineeName={index + 1}
                    index={nominee.sno as number}
                    key={nominee.sno as number}
                    values={values}
                    nationalitiesMdmsResponse={mdmsCountriesList}
                    address={address}
                    createdAt={application?.createdAt || ''}
                    ifXalt={ifXalt}
                    ifTopUp={application?.isTopup || false}
                  />
                </React.Fragment>
              ))}
          </>

          {values.nominees.filter((item) => item.isActive).length < 3 && (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                disabled={
                  isOnboardingTypeMinor(application?.onboardingType || '') ||
                  application?.isTopup ||
                  false
                }
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  mt: 2,
                }}
                onClick={() =>
                  setValues({
                    ...values,
                    nominees: [
                      ...values.nominees,
                      {
                        ...newNominee,
                        nomineePercentage: values.nominees.filter((item) => item.isActive).length
                          ? 0
                          : 100,
                        sno: values.nominees.length,
                        addressSameAsApplicant: true,
                        nomineeAddress1: checkAddressField(address?.address1),
                        nomineeAddress2: checkAddressField(address?.address2),
                        nomineeAddress3: checkAddressField(address?.address3),
                        nomineeCity: address?.city,
                        nomineeState: address?.state,
                        nomineeCountry: address?.country?.toUpperCase(),
                        nomineePincode: address?.pincode,
                        guardianAddress1: checkAddressField(address?.address1),
                        guardianAddress2: checkAddressField(address?.address2),
                        guardianAddress3: checkAddressField(address?.address3),
                        guardianCity: address?.city,
                        guardianState: address?.state,
                        guardianCountry: address?.country?.toUpperCase(),
                        guardianPincode: address?.pincode,
                      },
                    ],
                    doNotWishToNominate: false,
                  })
                }>
                Add Nominee
              </Button>
            </Grid>
          )}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                nominees: values.nominees.map((nominee) => ({
                  ...nominee,
                  nomineeRelationship:
                    //   checkValidationBasedOnDate(
                    //   application?.createdAt || '',
                    //   nomineeValidationDate
                    // )
                    ifXalt
                      ? nominee.Relationship
                      : nominee.Relationship === 'OTHERS'
                      ? nominee.nomineeRelationship
                      : nominee.Relationship,
                })),
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                nominees: values.nominees.map((nominee) => ({
                  ...nominee,
                  nomineeRelationship:
                    //   checkValidationBasedOnDate(
                    //   application?.createdAt || '',
                    //   nomineeValidationDate
                    // )
                    ifXalt
                      ? nominee.Relationship
                      : nominee?.Relationship === 'OTHERS'
                      ? nominee.nomineeRelationship
                      : nominee?.Relationship,
                })),
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
          <ConfirmationDialog
            message={'Are you sure you want to delete nominees ?'}
            open={nomineeToDelete !== null || bulkNomineeDelete !== false}
            setOpen={() => {
              setBulkNomineeDelete(false);
              setNomineeToDelete(null);
            }}
            onSave={async () => {
              try {
                const { id } = application || {};
                const remainedApplicants = values.nominees.map((nominee, i) => {
                  if (nominee.sno === nomineeToDelete?.index || bulkNomineeDelete) {
                    return {
                      ...nominee,
                      isActive: false,
                    };
                  }
                  return nominee;
                });
                setValues({
                  ...values,
                  nominees: remainedApplicants,
                  doNotWishToNominate:
                    remainedApplicants.filter((item) => item.isActive).length === 0
                      ? true
                      : values.doNotWishToNominate,
                });
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              } catch (e) {
                console.error((e as Error).message);
              }
            }}
            onCancel={() => {
              setBulkNomineeDelete(false);
              setNomineeToDelete(null);
            }}
          />
        </Grid>
      )}
    </Formik>
  );
}
